import SelectType from "components/select/type";
import useTableFilters from "@/hooks/useTableFilters";
import { FilterActions } from "components/filter/actions";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";

export default function MeTaskFilters({
  filters,
  setFilters,
  setIsOpen,
  isOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      type: undefined,
      ...defaultFilters,
    },
  });

  return (
    <FiltersList>
      <FilterWrapper label="Type">
        <SelectType
          collection="tasks"
          placeholder="Select Type"
          value={localFilters?.type?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              type: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
          clearable={true}
        />
      </FilterWrapper>

      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
